import { Directive, TemplateRef } from '@angular/core';

@Directive({
	selector: 'ng-template[aePgtFormCustom]',
})
export class PaginationTableFormModalCustomDirective {
	constructor(public template: TemplateRef<any>) {}
}
